import { render, staticRenderFns } from "./UserPlans.vue?vue&type=template&id=32d5e713&"
import script from "./UserPlans.vue?vue&type=script&lang=js&"
export * from "./UserPlans.vue?vue&type=script&lang=js&"
import style0 from "./UserPlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports